import React, { Component, ReactNode } from 'react'
import { SimpleReadingListBatchValidateResEntry } from 'stylewhere/api'
import { EntryRow, List } from 'stylewhere/components'
import { SimpleReadingListOperationConfig } from 'stylewhere/shared'
import { __, T } from 'stylewhere/shared/i18n'

interface Props {
  entries: SimpleReadingListBatchValidateResEntry[]
  simpleReadingListId?: string
  operation: SimpleReadingListOperationConfig
  emptyMessage?: string | React.ReactElement | null
}

interface State {
  entries: SimpleReadingListBatchValidateResEntry[]
}

export class EntryReadingList extends Component<Props, State> {
  state: State = {
    entries: this.props.entries
  }

  rowRender = (data: SimpleReadingListBatchValidateResEntry) => {
    const { operation } = this.props
    return (
      <EntryRow
        row={data}
        operation={operation}
        hasChecklist={operation.hasChecklist}
        showCounters={operation.hasChecklist}
        targetEntity={operation.targetEntity}
      />
    )
  }
  render() {
    const { entries, emptyMessage } = this.props
    return (
      <List
        data={entries}
        emptyMessage={
          emptyMessage === null ? undefined : emptyMessage ? (
            (emptyMessage as ReactNode)
          ) : (
            <span style={{ whiteSpace: 'break-spaces' }}>{__(T.messages.press_start_to_read)}</span>
          )
        }
        rowRender={this.rowRender}
      />
    )
  }
}
